import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { MissionPageContainer } from "../common_components/Layout";
import SubHeader from "./SubHeader";
import CompletedSessionsCard from "./overview_components/CompletedSessionsCard";
import CompletedSurveyResponsesCard from "./overview_components/CompletedSurveyResponsesCard";
import SchedulingCard from "./overview_components/SchedulingCard";
import MissionDetailsCard from "./overview_components/MissionDetailsCard";
import StatusCard from "./overview_components/StatusCard";
import RequirementsCard from "./overview_components/RequirementsCard";
import ScreenerCard from "./overview_components/ScreenerCard";
import FeatureFlag from "../../../utility_components/FeatureFlag";



// Api Calls
import MissionsAPI from "../../api/api_calls/MissionAPI";
import SurveyCard from "./overview_components/SurveyCard";


function MissionOverview(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingMission, setLoadingMission] = useState(true);
    const [missionCount, setMissionCount] = useState(0);

    const [mission, setMission] = useState({});
    const [missionType, setMissionType] = useState("")
    const [attendees, setAttendees] = useState([])
    const [missionEvent, setMissionEvent] = useState({})


    useEffect(() => {
        async function getMissionDetails() {
            const result = await MissionsAPI.show(missionId, navigate);

            if (result.success) {
                setMission(result.mission)
                setMissionType(result.mission_type)
                setMissionEvent(result.mission_event)
                setLoadingMission(false);
                setAttendees(result.mission_attendees)
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }
        getMissionDetails();
    }, [missionCount]);

    function refreshMission() {
        setMissionCount(missionCount + 1);
    }

    function addAttendee({ first_name, last_name, email }) {
        const attendee = { id: `temp_${email}`, first_name: first_name, last_name: last_name, email: email, removable: true }
        // Check if the email is already in the list
        if (attendees.find(att => att.email == email)) {
            alert.show("This email is already added", { type: 'error' })
            return;
        }
        setAttendees([...attendees, attendee]);
    }
    function deleteAttendee(id) {
        setAttendees(attendees.filter(attendee => attendee.id != id));
    }

    const responseComponents =
        missionType == "Live Feedback" ?
            <>
                <CompletedSessionsCard />
                <SchedulingCard mission={mission} />
            </>
            :
            missionType == "Survey" ?
                <>
                    <CompletedSurveyResponsesCard />
                    <SurveyCard />
                </>
                :
                <></>


    return (
        <>
            <SubHeader title={"Project Overview"} />
            <MissionPageContainer>
                {/* This swaps out the survey or interview components */}
                {responseComponents}
                <div className="horizontal-card-container">
                    <MissionDetailsCard mission={mission} missionType={missionType} refreshMission={refreshMission} loading={loadingMission} attendees={attendees} addAttendee={addAttendee} deleteAttendee={deleteAttendee} missionEvent={missionEvent} />
                    <StatusCard mission={mission} refreshMission={refreshMission} loading={loadingMission} />
                </div>
                <RequirementsCard />
                <ScreenerCard />
            </MissionPageContainer>
        </>

    )

}




export default MissionOverview;